import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import InitialsAvatar, { initialsFor } from "./InitialsAvatar";

describe("initialsFor", () => {
  it.each([
    ["Jennifer Hutchison", "JH"],
    ["  jennifer   hutchison  ", "JH"],
    ["Hutchison, Jennifer", "JH"], // "Last, First" reads as First Last
    ["Anna Maria Svensson", "AS"], // first and last word
    ["Madonna", "M"],
    ["Åsa Öberg", "ÅÖ"],
    ["", ""],
    ["   ", ""],
    ["42", "4"],
  ])("%j gives %j", (name, expected) => {
    expect(initialsFor(name)).toBe(expected);
  });
});

describe("InitialsAvatar", () => {
  it("shows the initials in an avatar next to the full name", () => {
    render(<InitialsAvatar name="Jennifer Hutchison" />);

    expect(screen.getByTestId("initials-avatar")).toHaveTextContent("JH");
    expect(screen.getByText("Jennifer Hutchison")).toBeInTheDocument();
  });

  it("renders nothing for an empty or blank name", () => {
    const { container } = render(<InitialsAvatar name="   " />);

    expect(container).toBeEmptyDOMElement();
  });
});
